import { ReactElement } from 'react';
import cc from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { CardWrapper } from './style';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

type TProps = {
  sportAlias?: string;
};

const matchInfoNameSports = [
  'PistolShooting',
  'PistolHead2Head',
  'ArcheryH2H',
  'CompoundArchery',
  'Archery',
  'BasketballShots'
];

export const MatchInfoCardSkeleton = (props: TProps): ReactElement => {
  return (
    <>
      <CardWrapper
        className={cc([
          `cardWrapper cardWrapper__skeleton ${props.sportAlias}`,
          { cardWrapper__mobile: isMobile(), cardWrapper__desktop: !isMobile() }
        ])}
      >
        <Skeleton
          active
          round
          title={{ width: '100%', style: { height: 14 } }}
          paragraph={false}
          className="matchHeader__skeleton"
        />
        <Skeleton
          active
          round
          title={{ width: '100%', style: { height: 14 } }}
          paragraph={false}
          className="matchHeader__skeleton"
        />
        <Skeleton
          active
          round
          title={{ width: '100%', style: { height: 14 } }}
          paragraph={false}
          className="matchHeader__skeleton"
        />
      </CardWrapper>
      {isMobile() && matchInfoNameSports.includes(props.sportAlias || '') && (
        <div className={cc([{ matchInfoName: isMobile() }])}>
          <div className="matchInfoName--mobile matchInfoName--desktop">
            <Skeleton.Avatar active size={EIconSize._20} shape="circle" />

            <span className="matchInfoName__label">
              <Skeleton
                active
                title={{
                  style: { width: 100, height: 14, margin: 0 }
                }}
                paragraph={false}
              />
            </span>
          </div>
        </div>
      )}
    </>
  );
};
